import React from "react";
import PropTypes from "prop-types";

import Text from "../text";
import styles from "./cards.module.css";

/**
 *
 * @param {JSX} icon The Icon element that represents the Settings action
 * @param {string} text The text literal that represents the Settings action
 * @returns
 */
const SettingsCard = ({
  icon,
  text,
  innerText,
  className,
  action = (e) => {},
  ...props
}) => {
  return (
    <div className={`${styles.Setting} ${className || ""}`} onClick={action}>
      <div>
        <div>{icon}</div>
      </div>
      <div>
        <Text variant="" style={{ fontWeight: "600" }}>
          {text}
        </Text>
        <Text
          variant="sm"
          style={{ color: "#64748B", paddingTop: innerText ? ".6rem" : null }}
        >
          {innerText}
        </Text>
      </div>
    </div>
  );
};

SettingsCard.propTypes = {
  icon: PropTypes.element,
  text: PropTypes.string,
};
export default SettingsCard;
